import { setClusterShowSteps as setClusterShowStepsDiagram , getClusterShowSteps as getClusterShowStepsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    show_steps?: boolean,
}

export const setClusterShowSteps = ({
    show_steps,
    eventEmitter,
}: Props) => {
   
    setClusterShowStepsDiagram(show_steps)
    apiProvider.updateDiagramCluster({source : 'setClusterShowSteps'});
};

export const getClusterShowSteps = (): Props => getClusterShowStepsDiagram();